import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import i18n from '@wix/wix-vod-shared/src/common/i18n';

import reportStats from 'widget/redux/server/actions/stats/report';
import STATS_EVENTS from 'shared/constants/stats/events';
import { openModal, closeCatcher } from 'shared/components/modal/modal';
import getUrlToVideo from '@wix/wix-vod-shared/src/common/utils/get-url-to-video';
import WixSDK from 'shared/utils/wix-sdk';
import deviceTypes from 'shared/constants/device-types';
import {
  openBuyVideoOverlay,
  openSubscribeOverlay,
} from 'widget/redux/client/actions/mobile-overlay-openners/payment-pages-actions';
import { openFullScreenPurchaseOverlay, openFullScreenSubscribeOverlay } from 'shared/utils/open-overlay';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getVideoIdFromUrl, getUrlParam } from 'widget/selectors/query-params.js';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';
import { areElementsRounded, getSiteUrl } from 'shared/selectors/app-settings';
import { toggleShareVideoOverlay } from 'widget/redux/client/actions/share-overlay';
import { isPayed } from 'shared/selectors/payments';

import ShareMobileContent from 'mobile/components/share-mobile/popup-content/popup-content';
import {
  URL_PARAM_STATE,
  URL_STATE_PURCHASE,
  URL_STATE_SHARE,
  URL_STATE_SUBSCRIBE,
} from '@wix/wix-vod-shared/src/common/constants/url';

import translations from 'messages/widget';
import { setCookie, hasCookie, removeCookie } from '@wix/wix-vod-shared/src/common/utils/cookie';

const DISABLING_COOKIE_NAME = 'vod-disable-deeplink-popups';

@connect(state => ({
  channelData: getChannelForWidget(state),
  videos: getVideosGroupedByIds(state),
  videoIdFromUrl: getVideoIdFromUrl(state),
  urlState: getUrlParam(state, URL_PARAM_STATE),
  areElementsRounded: areElementsRounded(state),
  siteUrl: getSiteUrl(state),
  appSettings: state.appSettings,
}), {
  reportStats,
  openBuyVideoOverlay,
  openSubscribeOverlay,
  toggleShareVideoOverlay,
})
export default class DeeplinkPopups extends React.Component {

  static propTypes = {
    channelData: PropTypes.object,
    videos: PropTypes.object,
    videoIdFromUrl: PropTypes.string,
    areElementsRounded: PropTypes.bool,
    siteUrl: PropTypes.string,
    reportStats: PropTypes.func,
    urlState: PropTypes.string,
    appSettings: PropTypes.object,
    openBuyVideoOverlay: PropTypes.func,
    openSubscribeOverlay: PropTypes.func,
    toggleShareVideoOverlay: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isShareOverlayOpened: false,
    };

    this.hasOpenedPopup = hasCookie(DISABLING_COOKIE_NAME);

    window.onbeforeunload = () => {
      removeCookie(DISABLING_COOKIE_NAME);
    };
  }

  componentDidMount() {
    this.openDeeplinkPopups(this.props);
  }

  componentWillUpdate(nextProps) {
    this.openDeeplinkPopups(nextProps);
  }

  get video() {
    const { videos = [], videoIdFromUrl } = this.props;
    return videos[videoIdFromUrl];
  }

  get isMobile() {
    return WixSDK.Utils.getDeviceType() === deviceTypes.MOBILE;
  }

  openDeeplinkPopups(props) {
    const { hasOpenedPopup, video } = this;
    const { channelData, urlState } = props;

    if (!urlState || hasOpenedPopup || !video || _.isEmpty(channelData)) {
      return;
    }

    switch (urlState) {
      case URL_STATE_SHARE:
        this.openSharePopup();
        break;
      case URL_STATE_PURCHASE:
        this.openPurchasePopup(channelData, video);
        break;
      case URL_STATE_SUBSCRIBE:
        this.openSubscribePopup(channelData);
        break;
      default:
        break;
    }

    this.hasOpenedPopup = true;
    setCookie(DISABLING_COOKIE_NAME, true);
  }

  openSharePopup() {
    return this.isMobile ? this.openMobileSharePopup() : this.openShareOverlay();
  }

  openPurchasePopup(channel, video) {
    const { openBuyVideoOverlay } = this.props;

    if (isPayed(video)) {
      return;
    }

    return this.isMobile ? openBuyVideoOverlay(video.id) : openFullScreenPurchaseOverlay(channel.id, video.id);
  }

  openSubscribePopup(channel) {
    const { openSubscribeOverlay } = this.props;

    if (isPayed(channel)) {
      return;
    }

    return this.isMobile ? openSubscribeOverlay(channel.id) : openFullScreenSubscribeOverlay(channel.id);
  }

  openShareOverlay() {
    this.props.toggleShareVideoOverlay();
  }

  @autobind
  sendStatsReport(name) {
    const { reportStats, channelData } = this.props;

    reportStats(STATS_EVENTS.VIDEO_SHARE, {
      channel: channelData,
      videoItem: this.video,
      network: {
        name,
      },
    });
  }

  openMobileSharePopup() {
    const { video } = this;
    const { appSettings } = this.props;
    const { title, customCoverUrl, coverUrl, description } = video;

    const shareParams = {
      siteUrl: getUrlToVideo(video, appSettings),
      title,
      description,
      coverUrl: customCoverUrl || coverUrl,
    };

    openModal({
      title: i18n.t(translations.shareVideo),
      content: (
        <ShareMobileContent shareParams={shareParams}
                            inputLabel="Accessible label"
                            onShare={this.sendStatsReport} />
      ),
    })
      .catch(closeCatcher);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/deeplink-popups/deeplink-popups.js